import * as _ from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { EventPageService } from 'app/event-page/services/event-page.service';
import { EventPageHeaderTypeService } from 'app/event-page/services/event-page-header-type.service';

@Component({
  selector: 'app-event-page-header-type02',
  templateUrl: './event-page-header-type02.component.html',
  styleUrls: ['./event-page-header-type02.component.scss']
})
export class EventPageHeaderType02Component implements OnInit {

  @Input () eventPageConfig = null;
  @Input () eventPageData = null;

  public customColorTheme = null;
  public infoContainerColors = null;
  public expanded = false;
  public registerBtnText = 'Register';
  public registerBtnClasses = {
    'disabled': false
  };
  public timezoneAbbreviation: string = '';
  public hideShareSection: boolean = false;

  constructor(
    public eventPageService: EventPageService,
    private eventPageHeaderTypeService: EventPageHeaderTypeService
  ) { }

  ngOnInit(): void {
    this.customColorTheme = this.eventPageConfig.customColorTheme;
    this.infoContainerColors = this.customColorTheme.informationContainerColors;
    
    if(this.eventPageData.registrationButtonLabelRequired) {
      this.registerBtnText = this.eventPageData.registrationButtonLabel
    } else if(this.eventPageConfig.registrations.length === 1) {
      this.registerBtnText = this.eventPageConfig.registrations[0].label
    }
    
    this.registerBtnClasses = {
      'disabled': this.eventPageConfig.isAllRegistrationsDisabled()
    };
    this.timezoneAbbreviation = this.eventPageHeaderTypeService.getUserTimezone();
    this.hideShareSection = this.eventPageConfig?.hideShareButtons || false;
  }
}
